import {
  IDeclaration,
  IDeclarationLine,
  IDocument,
  IProlongationRequest,
  IRequestData
} from "@/interfaces/declaration";
import { ajaxCall, ICancellableResult } from "@/tools/axios-wrapper";
import BaseApi from "./base-api";

class DeclarationsApi extends BaseApi<IDeclarationLine> {}
class DeclarationRPApi extends BaseApi<IDeclaration> {
  async getByIds(ids: Array<number>) {
    return await ajaxCall.get<Array<IDeclaration>>(this.apiUrl, {
      urlParameter: [this.objectName, "GetByIds"],
      queryParameter: { ids: ids.toString() }
    });
  }

  async createPRByDeclarationIds(ids: Array<number>): Promise<ICancellableResult<any>> {
    return await ajaxCall.post<Array<number>, any>(this.apiUrl, {
      urlParameter: [this.objectName, "CreatePRByDeclarationIds"],
      queryParameter: { ids: ids.toString() }
    });
  }

  async createOrUpdatePR(payload: IProlongationRequest): Promise<ICancellableResult<IProlongationRequest>> {
    if (payload.id > 0) {
      return await ajaxCall.patch<IProlongationRequest, IProlongationRequest>(this.apiUrl, {
        urlParameter: [this.objectName, "" + payload.declarationId, "ProlongationRequests", "" + payload.id],
        payload
      });
    } else {
      return await ajaxCall.post<IProlongationRequest, IProlongationRequest>(this.apiUrl, {
        urlParameter: [this.objectName, "" + payload.declarationId, "ProlongationRequests"],
        payload
      });
    }
  }
  async updatePRList(payload: IProlongationRequest[]): Promise<ICancellableResult<boolean>> {
    return await ajaxCall.post<boolean, IProlongationRequest[]>(this.apiUrl, {
      urlParameter: [this.objectName, "ProlongationRequests", "UpdateMany"],
      payload
    });
  }
  async requestDataCreateOrUpdate(payload: IRequestData): Promise<ICancellableResult<IRequestData>> {
    if (payload.id > 0) {
      return await ajaxCall.patch<IRequestData, IRequestData>(this.apiUrl, {
        urlParameter: [
          this.objectName,
          "" + payload.declarationId,
          "ProlongationRequests",
          "" + payload.prolongationRequestId,
          "RequestDatas",
          "" + payload.id
        ],
        payload
      });
    } else {
      return await ajaxCall.post<IRequestData, IRequestData>(this.apiUrl, {
        urlParameter: [
          this.objectName,
          "" + payload.declarationId,
          "ProlongationRequests",
          "" + payload.prolongationRequestId,
          "RequestDatas"
        ],
        payload: payload
      });
    }
  }

  async generatePdf(payload: IProlongationRequest, fileName: string): Promise<any> {
    return await ajaxCall.post<any, IRequestData>(this.apiUrl, {
      urlParameter: [
        this.objectName,
        "" + payload.declarationId,
        "ProlongationRequests",
        "" + payload.id,
        "GeneratePdf"
      ],
      payload: payload.requestData,
      fileDownloadName: fileName
    });
  }

  async uploadDocument(payload: IDocument, declarationId: number): Promise<ICancellableResult<IDocument>> {
    return await ajaxCall.post<IDocument, IDocument>(this.apiUrl, {
      urlParameter: [
        this.objectName,
        "" + declarationId,
        "ProlongationRequests",
        "" + payload.prolongationRequestId,
        "Documents"
      ],
      payload
    });
  }

  async downloadDoc(payload: IDocument, fileName: string): Promise<any> {
    return await ajaxCall.get<any>(this.apiUrl, {
      urlParameter: [
        this.objectName,
        "ProlongationRequests",
        "" + payload.prolongationRequestId,
        "Documents",
        "" + payload.id
      ],
      fileDownloadName: fileName
    });
  }

  async deleteDoc(payload: IDocument): Promise<ICancellableResult<boolean>> {
    return await ajaxCall.delete<boolean>(this.apiUrl, {
      urlParameter: [
        this.objectName,
        "ProlongationRequests",
        "" + payload.prolongationRequestId,
        "Documents",
        "" + payload.id
      ]
    });
  }

  async downloadDocumentsForPr(prolongationRequestId: number, fileName: string): Promise<any> {
    return await ajaxCall.get<any>(this.apiUrl, {
      urlParameter: [this.objectName, "ProlongationRequests", "" + prolongationRequestId, "DownloadDocumentsForPr"],
      fileDownloadName: fileName
    });
  }

  async downloadDocumentsByIds(ids: Array<number>, fileName: string): Promise<any> {
    return await ajaxCall.get<any>(this.apiUrl, {
      urlParameter: [this.objectName, "DownloadDocumentsByIds"],
      queryParameter: { ids: ids.toString() },
      fileDownloadName: fileName
    });
  }
}

const declarationApi = new DeclarationsApi("Declarations", "declaration");
const declarationRPApi = new DeclarationRPApi("Declarations", "declaration");
export { declarationApi, declarationRPApi };
